import type { SinglePagePdf } from "@pdfking/pdfengine"
import { FileContentGUID } from "@pdfking/pdfengine"

import type { FileSlot } from "#public"

/** A page already at hand as a slot's page: its boxes and identity read off it. */
export const FileSlotPage = (page: SinglePagePdf): NonNullable<FileSlot["page"]> => ({
  bleed: page.bleed,
  get_file: () => Promise.resolve(page),
  guid: FileContentGUID(page),
  trim: page.trim,
})
